import type { DisplayMode, DisplayState } from '../desktop/display';

/**
 * Cienki wrapper nad mostkiem desktopowym `window.gierka.display`. Izoluje
 * resztę renderera od szczegółów IPC i od tego, że na web mostek nie istnieje —
 * tam `isDesktopDisplay()` zwraca `false`, a pozostałe metody są no-op/null.
 */

export function isDesktopDisplay(): boolean {
  return typeof window !== 'undefined' && !!window.gierka?.display;
}

export async function getDisplay(): Promise<DisplayState | null> {
  if (!window.gierka?.display) return null;
  return window.gierka.display.get();
}

export async function setMode(mode: DisplayMode): Promise<DisplayState | null> {
  if (!window.gierka?.display) return null;
  return window.gierka.display.setMode(mode);
}

export async function setWindowSize(width: number, height: number): Promise<DisplayState | null> {
  if (!window.gierka?.display) return null;
  return window.gierka.display.setWindowSize(width, height);
}

/** Subskrybuje zmiany stanu; zwraca funkcję odsubskrybowania (no-op na web). */
export function onDisplayChange(cb: (state: DisplayState) => void): () => void {
  if (!window.gierka?.display) return () => {};
  return window.gierka.display.onChange(cb);
}
